import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import withDropdownActions from 'hoc/withDropdownActions';
// components
import { FormattedMessage } from 'react-intl';
import Panel from 'components/Panel/Panel';
import Preloader from 'components/Preloader';
import NothingBox from 'components/NothingBox';
import DataTable from 'components/DataTable/DataTable';
import CustomColumn from 'components/DataTable/Columns/CustomColumn';
import SearchBox from 'components/SearchBox';
import { SurveyReminderBadge } from 'components/StatusBadge/StatusBadge';
// utils
import { isTablet } from 'react-device-detect';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUser } from 'utils/regionalDateHelper';
// styles
import './BarnsheetsGroupSurveysTable.scss';

class BarnsheetsGroupSurveysTable extends Component {
  renderDateColumn = ({ created_on }) => {
    const formattedDate = formatDateForUser(created_on, this.props.countryCode);
    return (
      <CustomColumn label={<FormattedMessage id="general.date" />}>
        <span className="сolor-primary">{formattedDate}</span>
      </CustomColumn>
    );
  };

  renderQuestionColumn = ({ question, reminder }) => (
    <CustomColumn label={<FormattedMessage id="component.dataTable.headers.integration" />}>
      {question ? (
        <span className="сolor-primary">{question}</span>
      ) : 'N/A'}
      {reminder && <SurveyReminderBadge className="ml-5" />}
    </CustomColumn>
  );

  renderAnswerColumn = ({ value, open_answer, value_text }) => (
    <CustomColumn label={<FormattedMessage id="component.dataTable.headers.answer" />}>
      <span className="сolor-primary">
        {open_answer ? (value_text || 'N/A') : <FormattedMessage id={`general.button.${value ? 'yes' : 'no'}`} />}
      </span>
    </CustomColumn>
  );

  render() {
    const { isLoading, data, sort, onSortChange, paginationProps, reqParams: { search }, onSearchChange } = this.props;

    const columns = [
      {
        label: <FormattedMessage id="general.date" />,
        flex: '1 1 170px',
        renderer: this.renderDateColumn,
        sortKey: 'created_on'
      },
      {
        label: <FormattedMessage id="component.dataTable.headers.question" />,
        flex: '1 1 170px',
        renderer: this.renderQuestionColumn,
        sortKey: 'question'
      },
      {
        label: <FormattedMessage id="component.dataTable.headers.answer" />,
        flex: '1 1 170px',
        renderer: this.renderAnswerColumn,
        sortKey: 'value'
      },
    ];

    return (
      <Panel className="BarnsheetsGroupSurveysTable">
        <Panel.Heading title={<FormattedMessage id="general.surveyQuestions" />}>
          <SearchBox initialValue={search} onChange={onSearchChange} />
        </Panel.Heading>
        <Panel.Body noPadding>
          <Preloader isActive={isLoading} />
          <DataTable
            data={data}
            columns={columns}
            sort={sort}
            onSortChange={onSortChange}
            paginationProps={paginationProps}
            isExpandable={isTablet}
            scrollable
            tableKey="barnsheetsWaterUsage"
          />
          <NothingBox
            display={!data.length}
            isLoading={isLoading}
          >
            <h2 className="lighter"><FormattedMessage id="component.nothingBox.noData" /></h2>
          </NothingBox>
        </Panel.Body>
      </Panel>
    );
  }
}

BarnsheetsGroupSurveysTable.contextTypes = {
  router: T.object.isRequired,
};

BarnsheetsGroupSurveysTable.propTypes = {
  isLoading: T.bool.isRequired,
  data: T.array.isRequired,
  sort: T.string.isRequired,
  onSortChange: T.func.isRequired,
  paginationProps: T.object.isRequired,
  reqParams: T.object.isRequired,
  onSearchChange: T.func.isRequired,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    currentUser: state.auth.user,
    isLoading: state.dataTable.barnsheetsGroupSurveys.isLoading,
    countryCode: getCurrentCountryCode(state),
  })
)(withDropdownActions(BarnsheetsGroupSurveysTable));
